import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconMathEquals: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconMathEquals"><Path fillRule="evenodd" clipRule="evenodd" d="M4 8H20V10H4V8Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M4 14H20V16H4V14Z" fill="currentColor"/></CentralIconBase>;
});

export default IconMathEquals;
